// exclude-from-index
import PropTypes from 'prop-types';
import React from 'react';

import { StyledContainer } from './Container.styles';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

function Container(props) {
  const { nogutter, children } = props;
  return (
    <StyledContainer {...props} nogutter={nogutter ? 1 : 0}>
      {children}
    </StyledContainer>
  );
}

Container.propTypes = {
  /** Remove the additional gutter that is applied to container. */
  nogutter: PropTypes.bool,
  children: ReactChildrenPropType
};

Container.defaultProps = {
  nogutter: false,
  children: undefined
};

export default Container;
